
<template>
  <h1
    v-if='sub.length > 0'
    class="sub"
  >
    {{sub}}
  </h1>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'SubTitulo',
  data () {
    return {
      sub: '',
    }
  },
  apollo: {
    settings: {
      query: gql`
      query MyQuery {
        settings: settings(where:{key:{_eq:"Sub_Titulo_Live"}}){
          value
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.settings.length > 0) {
            this.sub = data.settings[0].value
            console.log(data.settings[0].value)
          }
        }
      },
    },
  },
  mounted () {
    setInterval(() => {
      if (Object.keys(this.$apollo.queries).includes('settings')) {
        this.$apollo.queries.settings.refetch()
      }
    }, 5000)
  },
}
</script>

<style scoped>
.sub {
  text-align: left;
  padding-top: 4px;
  padding-left: 40px;
  color: #ffffff;
  font-size: 45px;
  font-family: "Menlo", monospace;
}
</style>
